import { render, staticRenderFns } from "./IpCell.vue?vue&type=template&id=2b70a796&"
import script from "./IpCell.vue?vue&type=script&lang=js&"
export * from "./IpCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports